import { Flex, Text, useDisclosure } from "@chakra-ui/react";
import { Races } from "api/generated/graphql";
import ReducedConditions from "components/Conditions/ReducedConditions";
import { IconInfoAccordion } from "icons";
import { 
  AIR_TEMPERATURE_CATEGORY, 
  TRACK_TEMPERATURE_CATEGORY, 
  WIND_CATEGORIES, 
  WEATHER_CATEGORIES, 
  ROUGHNESS_CATEGORIES, 
  TARMAC_CONDITION_CATEGORIES 
} from 'components/Conditions/enums';
import ForecastModal from "components/Modals/ForecastModal/ForecastModal";

const Forecast = ({
  race,
}: {
  race: Races;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Flex w="full" flexDir="column" gap="2" pb="4">
      <Flex
        background="linear-gradient(270deg, rgba(255, 53, 57, 0) 0%, rgba(255, 53, 57, 0.096) 50%, rgba(255, 53, 57, 0) 100%)"
        p="2"
        borderTopRadius="40px"
        position="relative"
        alignItems="center"
        justifyContent="center"
        gap="2"
        _before={{
          content: '""',
          position: 'absolute',
          inset: 0,
          padding: '0px',
          paddingBottom: '2px',
          background: 'linear-gradient(270deg, rgba(255, 53, 57, 0) 0%, rgba(255, 53, 57, 0.096) 50%, rgba(255, 53, 57, 0) 100%)',
          mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
          maskComposite: 'exclude',
          zIndex: -1,
        }}
        onClick={onOpen}
      >
        <Text
          color="bloodMoon.100"
          fontSize={{ base: '0.75rem', md: '0.875rem' }}
          lineHeight="120%"
          fontWeight="400"
          fontFamily="heading"
          textTransform="uppercase"
        >
          Forecast
        </Text>
        <IconInfoAccordion 
          width="0.75rem"
          height="0.75rem"
          onClick={onOpen}
          cursor="pointer"
          __css={{
            path: {
              fill: 'bloodMoon.100',
            },
          }}
        />
      </Flex>

      <ReducedConditions 
          airTemperature={race?.airTemperatureCategory as unknown as AIR_TEMPERATURE_CATEGORY}
          trackTemperature={race?.trackTemperatureCategory as unknown as TRACK_TEMPERATURE_CATEGORY}
          wind={race?.windCategory as unknown as WIND_CATEGORIES}
          rain={race?.weatherCategory as unknown as WEATHER_CATEGORIES}
          roughness={race?.trackRoughnessCategory as unknown as ROUGHNESS_CATEGORIES}
          tarmacCondition={race?.tarmacConditionCategory as unknown as TARMAC_CONDITION_CATEGORIES}
          reduced={false}
        />

        <ForecastModal
          isOpen={isOpen}
          onClose={onClose}
        />
    </Flex>
  );
};

export default Forecast;
